import { render } from "./ResourceViewerModal.vue?vue&type=template&id=5ec386e6&scoped=true&ts=true"
import script from "./ResourceViewerModal.vue?vue&type=script&lang=ts"
export * from "./ResourceViewerModal.vue?vue&type=script&lang=ts"

import "./ResourceViewerModal.vue?vue&type=style&index=0&id=5ec386e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec386e6"]])

export default __exports__